// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2795":"9668d375","6122":"9668d375","6985":"551deffb","7207":"9668d375","7336":"9668d375","7482":"3f9efffa"}[chunkId] + ".chunk.css";
};